module.exports = __webpack_public_path__ + "static/media/Screenshot_4.8c0ba85c.png";